// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.copy-button {
  border: 1px solid transparent;
  background-color: transparent;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  flex-direction: row;
  position: relative;
  transition-duration: .2s;
  gap: 5px;
  color: var(--lightest_legible_grey);
}

.copy-button.intent-success {
  color: var(--success_color);
}
.copy-button.intent-danger {
  color: var(--red);

}`, "",{"version":3,"sources":["webpack://./src/components/presentational/CopyButton/CopyButton.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,wBAAwB;EACxB,QAAQ;EACR,mCAAmC;AACrC;;AAEA;EACE,2BAA2B;AAC7B;AACA;EACE,iBAAiB;;AAEnB","sourcesContent":[".copy-button {\n  border: 1px solid transparent;\n  background-color: transparent;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  flex-direction: row;\n  position: relative;\n  transition-duration: .2s;\n  gap: 5px;\n  color: var(--lightest_legible_grey);\n}\n\n.copy-button.intent-success {\n  color: var(--success_color);\n}\n.copy-button.intent-danger {\n  color: var(--red);\n\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
